import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, FlaskConicalIcon, GiftIcon, ZapIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { productBrand, productImage, totalBonuses, totalVolumes } from '../data/offer';
const highlights = [{
  icon: BookOpenIcon,
  label: `${totalVolumes} professional volumes`
}, {
  icon: GiftIcon,
  label: `${totalBonuses} exclusive bonuses`
}, {
  icon: ZapIcon,
  label: 'Instant access'
}];
export function Hero() {
  const scrollToPricing = () => document.getElementById('pricing')?.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
  return <section className="relative isolate overflow-hidden bg-background" data-id="element-84" data-mp="s9zxxe4wz0l5">
      <div className="flex h-1 w-full" aria-hidden="true" data-id="element-85" data-mp="nczsn5fw21v3">
        <span className="flex-1 bg-primary" data-id="element-86" data-mp="nekn6v27dksy" />
        <span className="w-24 bg-accent" data-id="element-87" data-mp="3d1s9sv56tfs2" />
        <span className="flex-1 bg-primary" data-id="element-88" data-mp="3czfkfwx3o34z" />
      </div>

      <div className="mx-auto max-w-5xl px-4 pb-14 pt-10 text-center lg:pb-20 lg:pt-14" data-id="element-89" data-mp="381e3bhj8idw5">
        <motion.p initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="inline-flex items-center gap-2 rounded-full border border-accent/40 bg-surface px-4 py-2 text-xs font-bold uppercase tracking-[.14em] text-foreground" data-id="element-90" data-mp="3j89618jhw3nf">
          <FlaskConicalIcon className="h-4 w-4 text-accent" aria-hidden="true" data-id="element-91" data-mp="30i18r72h87f5" /> {productBrand}
        </motion.p>

        

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.12,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-8 max-w-3xl" data-id="element-92" data-mp="3599k48nda2uy">
          <img src={productImage} alt="Industrial Chemistry & Chemical Processes Professional Edition: six volumes and five bonus resources covering fundamentals, unit operations, chemical production, process control, safety and optimization" className="mx-auto w-full drop-shadow-2xl" data-id="element-93" data-mp="2hj5e5umphr0s" />
        </motion.div>

        <div className="mt-9" data-id="element-94" data-mp="nbl58stuaue5">
          <Button onClick={scrollToPricing} arrow className="w-full sm:w-auto" data-id="element-95" data-mp="na9zwokqxekx">
            Get your professional edition now
          </Button>
        </div>

        <ul className="mt-7 flex flex-wrap justify-center gap-2 text-xs font-bold text-foreground" data-id="element-96" data-mp="dd5e4putbl4n">
          {highlights.map(({
          icon: Icon,
          label
        }) => <li key={label} className="inline-flex items-center gap-1.5 rounded-lg border border-primary/50 bg-surface px-3 py-2" data-id="element-97" data-mp="1b049mx9rqn0y">
              <Icon className="h-3.5 w-3.5 text-accent" aria-hidden="true" data-id="element-98" data-mp="112g55fmd215l" />
              {label}
            </li>)}
        </ul>
      </div>
    </section>;
}